import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext.js';
import { ErrorBoundary } from './components/ErrorBoundary.js';
import AppShell from './AppShell.js';
import DashboardPage from './pages/DashboardPage.js';
import JobsListPage from './pages/JobsListPage.js';
import JobCreatePage from './pages/JobCreatePage.js';
import DispatchPage from './pages/DispatchPage.js';
import JobDetailPage from './pages/JobDetailPage.js';
import CheckInPage from './pages/CheckInPage.js';
import PhotoCapturePage from './pages/PhotoCapturePage.js';
import SignaturePage from './pages/SignaturePage.js';
import PartsPage from './pages/PartsPage.js';
import ScanItemPage from './pages/ScanItemPage.js';
import TimeLogPage from './pages/TimeLogPage.js';
import ReportPage from './pages/ReportPage.js';
import ClientsPage from './pages/ClientsPage.js';
import ClientDetailPage from './pages/ClientDetailPage.js';
import TechniciansPage from './pages/TechniciansPage.js';
import ReportsPage from './pages/ReportsPage.js';
import CalendarPage from './pages/CalendarPage.js';
import MapPage from './pages/MapPage.js';
import InvoicesPage from './pages/InvoicesPage.js';
import AuditLogPage from './pages/AuditLogPage.js';
import { NotFoundPage } from './pages/NotFoundPage.js';
import SettingsPage from './pages/SettingsPage.js';
import WelcomePage from './pages/WelcomePage.js';

function LoadingScreen() {
  return (
    <div className="flex h-full items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-3">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary border-t-transparent" />
        <p className="text-sm text-muted-foreground">Loading TheOne Onsite...</p>
      </div>
    </div>
  );
}

function LoginRedirect() {
  const hubUrl = import.meta.env.VITE_HUB_URL ?? 'https://hub.theonestack.com';
  window.location.href = `${hubUrl}/login?return=${encodeURIComponent(window.location.href)}`;
  return null;
}

export default function App() {
  const { user, loading } = useAuth();

  if (loading) return <LoadingScreen />;
  if (!user) return <LoginRedirect />;

  return (
    <ErrorBoundary>
    <Routes>
      <Route path="/welcome" element={<WelcomePage />} />
      <Route path="/" element={<AppShell />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="jobs" element={<JobsListPage />} />
        <Route path="jobs/new" element={<JobCreatePage />} />
        <Route path="jobs/:id" element={<JobDetailPage />} />
        <Route path="jobs/:id/checkin" element={<CheckInPage />} />
        <Route path="jobs/:id/photos" element={<PhotoCapturePage />} />
        <Route path="jobs/:id/signature" element={<SignaturePage />} />
        <Route path="jobs/:id/parts" element={<PartsPage />} />
        <Route path="jobs/:id/scan" element={<ScanItemPage />} />
        <Route path="jobs/:id/time" element={<TimeLogPage />} />
        <Route path="jobs/:id/report" element={<ReportPage />} />
        <Route path="dispatch" element={<DispatchPage />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="map" element={<MapPage />} />
        <Route path="clients" element={<ClientsPage />} />
        <Route path="clients/:id" element={<ClientDetailPage />} />
        <Route path="technicians" element={<TechniciansPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="invoices" element={<InvoicesPage />} />
        <Route path="audit-log" element={<AuditLogPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
    </ErrorBoundary>
  );
}
